import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/pitchyou-logo.png'


const _hoisted_1 = { class: "bg-footer-black text-white flex column min-full-height" }
const _hoisted_2 = { class: "q-pa-md flex-grow-max" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 q-mb-xs\"><div class=\"q-mb-sm\"><div class=\"logo\"><img src=\"" + _imports_0 + "\" class=\"img-fluid\"></div></div><p class=\"footer-description company-info\"> PitchYou GmbH, Campusallee 9 | 51379 Leverkusen </p></div>", 1)
const _hoisted_5 = { class: "col-12 q-mb-xs" }
const _hoisted_6 = { class: "text-h6 text-bold q-mb-sm" }
const _hoisted_7 = { class: "footer-description" }
const _hoisted_8 = {
  class: "text-white",
  href: "https://www.pitchyou.de/impressum/",
  target: "_blank"
}
const _hoisted_9 = {
  class: "text-white",
  href: "https://www.pitchyou.de/datenschutz/",
  target: "_blank"
}
const _hoisted_10 = {
  class: "text-white",
  href: "https://www.pitchyou.de/nutzungsbedingungen/",
  target: "_blank"
}
const _hoisted_11 = { class: "copyright text-center q-py-md" }

import { ref } from 'vue';

const name = 'BrandDrawer';

export default /*#__PURE__*/_defineComponent({
  __name: 'BrandDrawer',
  props: ['showTermsOfUse'],
  setup(__props) {

const props = __props;
const showTermsOfUse = ref<boolean | undefined>(props.showTermsOfUse);
function currentYear() {
  return new Date().getFullYear();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.aboutUsLbl')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, [
                _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('message.privacyPolicyFLbl')), 1)
              ]),
              _withDirectives(_createElementVNode("p", null, [
                _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('message.termsOfUseFLbl')), 1)
              ], 512), [
                [_vShow, showTermsOfUse.value]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, " © " + _toDisplayString(currentYear()) + " PitchYou GmbH ", 1)
  ]))
}
}

})